const reducer = (state, action) => {

    switch (action.type) {
        case 'LOADING':
            return ({ ...state, loading: action.payload })
        case 'CLASSES':
            return ({ ...state, classes: action.payload, loading: false })
        case 'GROUPS':
            return ({ ...state, groups: action.payload, loading: false })
        case 'ACTIVITIES':
            return ({ ...state, activities: action.payload, loading: false })
        case 'INCMOE_ESTIMATE_CLASS':
            return ({ ...state, incomeEstimateClassList: action.payload.data, loading: false })
        case 'INCOME_RESOURCE_VALUES':
            return ({ ...state, incomeResourceValues: action.payload, loading: false })
        case 'INTEREST_REASON_VALUES':
            return ({ ...state, interestReasonValues: action.payload, loading: false })
        case 'FINE_REASON_VALUES':
            return ({ ...state, fineReasonValues: action.payload, loading: false })
        case 'DISCOUNT_REASON_VALUES':
            return ({ ...state, discountReasonValues: action.payload, loading: false })
        case 'PERMIT_REASON_VALUES':
            return ({ ...state, permitReasonValues: action.payload, loading: false })
        case 'INCOME_TAX_REPORT':
            return ({ ...state, incomeTaxReports: action.payload, loading: false })
        case 'STAGES_TRANSACTION_TYPE':
            return ({ ...state, stageTransactionType: action.payload, loading: false })
        case 'ROLE_STAGES_TRANSACTION_TYPE_PERMISSION':
            return ({ ...state, roleStageTransactionTypePermission: action.payload, loading: false })
        case 'INACTIVE':
            return ({ ...state, inactive: action.payload, loading: false })
        case 'APPROVAL':
            return ({ ...state, Approval: action.payload, loading: false })
        case "GROUP_OF_CAREER":
            return {
                ...state,
                GroupsOfCareers: action.payload.data,
                loading: false,
            };
        case "OTHER_BUSINESSES_LIST":
            return ({ ...state, otherBusinessesList: action.payload, loading: false })
        case "USER_INFO":
            return { ...state, User: action.payload, loading: false };
        case 'COMMITTEE_STATUSES_LIST':
            return ({ ...state, committeeStatusesList: action.payload, loading: false })
        case 'ACTIVITIES_BY_INCOME_TAX_REPORT_ID':
            return ({ ...state, activitiesByIncomeTaxReportId: action.payload, loading: false })
        case 'OTHER_BUSINESS_FORM':
            return ({ ...state, otherBusinessForm: action.payload.data, loading: false })
        case 'DATA':
            return ({ ...state, data: action.payload, loading: false })
        case 'BRANCHES':
            return ({ ...state, branches: action.payload, loading: false })
        case 'ROLES':
            return ({ ...state, roles: action.payload, loading: false })
        case 'PERMISSIONS':
            return ({ ...state, permissions: action.payload, loading: false })
        case 'STAGES':
            return ({ ...state, stages: action.payload, loading: false })
        case 'SECTIONS':
            return ({ ...state, sections: action.payload, loading: false })
        case 'TRANSACTIONTYPES':
            return ({ ...state, transactionTypes: action.payload, loading: false })
        case 'USERS':
            return ({ ...state, users: action.payload, loading: false })
        case 'BRANCH_ROLE_USER':
            return ({ ...state, branchRoleUsers: action.payload, loading: false})
        case 'BRANCH_LIST':
            return ({ ...state, branchesList: action.payload, loading: false})
        
    }
    return state
}

export default reducer;
